import React from 'react';
import storyBg from '../../../assets/site/bg-stories.jpg';
import Section from '../../site/components/Section';
import cx from '../../site/utils/cx';
import ui from '../../site/styles/primitives.module.css';
import { story } from '../aboutContent';
import styles from './OurStory.module.css';

const OurStory = () => (
  <Section id="story" background={storyBg} backgroundPosition="center 48%">
    <div className={cx(ui.wrap, styles.grid)}>
      <div data-reveal="">
        <span className={ui.eyebrow}>Our story</span>
        <h2 className={styles.title}>
          A legacy of <span className={ui.grad}>excellence and integrity</span>
        </h2>
        <p className={styles.vision}>{story.vision}</p>
      </div>

      <div className={cx(styles.panel, ui.glass)} data-reveal="">
        {story.paragraphs.map((paragraph) => (
          <p key={paragraph.slice(0, 32)}>{paragraph}</p>
        ))}
        <p className={styles.invitation}>{story.invitation}</p>
      </div>
    </div>
  </Section>
);

export default OurStory;
